// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import {
  CREATE_PRICE_BOOK,
  DELETE_PRICE_BOOK,
  GET_PRICE_BOOK_DETAIL,
  GET_PRICE_BOOK_LIST,
  UPDATE_PRICE_BOOK,
} from '~/utils/constants/actionType';
import { IQueryParamBase } from '~/utils/interface/common';
import { IFormPriceBook, IQueryUpdatePriceBook } from '~/utils/interface/priceBook';
import priceBookApi from '~/apis/priceBook';

export const getPriceBookList = createAsyncThunk(
  GET_PRICE_BOOK_LIST,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await priceBookApi.getPriceBookList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createPriceBook = createAsyncThunk(
  CREATE_PRICE_BOOK,
  async (body: IFormPriceBook, { rejectWithValue }) => {
    try {
      const resp = await priceBookApi.createPriceBook(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getPriceBookDetail = createAsyncThunk(
  GET_PRICE_BOOK_DETAIL,
  async (priceBookId: string, { rejectWithValue }) => {
    try {
      const resp = await priceBookApi.getPriceBookDetail(priceBookId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updatePriceBook = createAsyncThunk(
  UPDATE_PRICE_BOOK,
  async (payload: IQueryUpdatePriceBook, { rejectWithValue }) => {
    try {
      const resp = await priceBookApi.updatePriceBook(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deletePriceBook = createAsyncThunk(
  DELETE_PRICE_BOOK,
  async (priceBookId: string, { rejectWithValue }) => {
    try {
      const resp = await priceBookApi.deletePriceBook(priceBookId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
